import React from 'react';
import PropTypes from 'prop-types';
import { useOkapiKy } from '@folio/stripes-core';
import ExportTranslationsForm from './ExportTranslationsForm';

function ExportTranslationsManager(props) {
  const okapiKy = useOkapiKy();

  const onFormSubmit = async (values) => {
    const {
      fileType = 'json',
      exportFields = 'key+value',
      fileName,
    } = values;

    const {
      currentLocale,
      categoryName,
      selectedTranslations = [],
      contentData = [],
    } = props;

    // Build query params
    const params = new URLSearchParams({ localeValue: currentLocale });
    if (categoryName) params.set('categoryName', categoryName);
    if (fileType)     params.set('format', fileType);
    if (exportFields) params.set('fields', exportFields);
    if (fileName)     params.set('fileName', fileName);

    // If specific rows selected — pass their IDs
    const toExport = selectedTranslations.length > 0
      ? selectedTranslations
      : contentData;
    if (selectedTranslations.length > 0) {
      const ids = toExport
        .map(t => t.id)
        .filter(Boolean)
        .join(',');
      if (ids) params.set('selectedIds', ids);
    }

    try {
      const response = await okapiKy.get(
        `translation-keys/export?${params.toString()}`,
        { parseJson: false }
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName || 'translations'}.${fileType}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Export failed', e);
    }
  };

  return (
    <ExportTranslationsForm
      {...props}
      onSubmit={onFormSubmit}
      initialValues={{
        fileName: props.fileName || '',
        fileType: 'json',
        exportFields: 'key+value',
      }}
    />
  );
}

ExportTranslationsManager.propTypes = {
  contentData: PropTypes.array,
  selectedTranslations: PropTypes.array,
  currentLocale: PropTypes.string,
  categoryName: PropTypes.string,
  fileName: PropTypes.string,
};

export default ExportTranslationsManager;
